import { InjectionToken } from '@angular/core';
import { ApMessageService } from './ap-message.service';

export const ApMessageToken = new InjectionToken<ApMessageService>('ApMessageService');
